/*
 * The Advanced Table's grid in components.css assumes the global
 * `*, *::before, *::after { box-sizing: border-box }` reset the documentation site has.
 * Without it the cells' `height: 100%` adds their padding on top of the row's height,
 * so every cell overflows its row by ~30px and the header covers the first row.
 * A product page cannot be asked for a reset, so the component sets it on its own parts.
 */
.i80-advanced-table,
.i80-advanced-table__container,
.i80-advanced-table__thead,
.i80-advanced-table__tbody,
.i80-advanced-table__tr,
.i80-advanced-table__th,
.i80-advanced-table__td,
.i80-advanced-table__th-content,
.i80-advanced-table__th-button,
.i80-advanced-table__th-resize-handle,
.i80-advanced-table__empty-state {
  box-sizing: border-box;
}

/*
 * The Ember component's header cell is a <div>; a real <th> is bold and centred by the
 * browser's own stylesheet, which components.css only overrides for the body cells.
 */
.i80-advanced-table__thead .i80-advanced-table__th {
  font-weight: var(--i80-typography-font-weight-regular);
  text-align: left;
}
